export enum SortOrderOption {
  ENTITY_ID_FIRST = 'ENTITY_ID_FIRST',
  FORM_NAME_FIRST = 'FORM_NAME_FIRST',
}
